module.exports = __webpack_public_path__ + "static/media/StarSysLogo.034f94c9.svg";